import React from 'react';
import PropTypes from 'prop-types';
import loadable from '@loadable/component';
import { connect } from 'react-redux';
import withNavigate from '~/hocs/withNavigate';
import { toast } from 'react-toastify';
import { Helmet } from 'react-helmet';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Image from 'react-bootstrap/Image';
import Tab from 'react-bootstrap/Tab';
import Tabs from 'react-bootstrap/Tabs';
import descend from 'ramda/src/descend';
import filter from 'ramda/src/filter';
import find from 'ramda/src/find';
import isEmpty from 'ramda/src/isEmpty';
import prop from 'ramda/src/prop';
import propEq from 'ramda/src/propEq';
import sort from 'ramda/src/sort';
import sortWith from 'ramda/src/sortWith';
import Button from '@components/@core/AnimatedButton';
import Dropdown from '@components/@core/Dropdown';
import ErrorBoundary from '@components/@core/ErrorBoundary';
import Icon from '@components/@core/Icon';
import Rating from '@components/@core/Rating';
import SearchBox from '../SearchBox/searchBox';
import AppActions from '~/actions/app';
import VendorActions from '~/actions/vendor';
import { history } from '~/reducers';
import { convertUrl, capitalize } from '~/services/util';
import { RATING_STATUS } from '~/services/constants';
import Product from './PopularProduct';

const Select = loadable(() => import('react-select'), { ssr: false });

const vendorWorks = [
    {
        icon: 'fas fa-star',
        info: 'Dealers rate and reviews the products they use.',
    },
    {
        icon: 'fas fa-headset',
        info: 'Each review is verified by phone before being published',
    },
    {
        icon: 'fas fa-search',
        info: 'Verified ratings and feedback guide you to the right vendor.',
    },
];

const icon = ['fas fa-business-time', 'fas fa-tools', 'fas fa-user-tie', 'fas fa-file-alt', 'fas fa-phone', 'fas fa-warehouse', 'fas fa-store', 'fas fa-user-md'];

class Home extends React.Component {
    state = {
        vendor: null,
        products: [],
        showProducts: 8,
        rating: 0,
        companyName: [],
        companyId: '',
        productId: '',
        recommend: 0,
        activeTab: 'company',
        company: '',
        mappedCompanies: [],
        productList: [],
        selectedCompany: [null],
        selectedCategory: [null],
        selectedProduct: [null],
    };

    static getDerivedStateFromProps(nextProps, prevState) {
        const { categories } = nextProps;
        const { all } = categories;
        let products = [];
        all.forEach((item) => {
            if (item.popular) {
                if (item.popular.data) {
                    const product = item.popular.data;
                    product.forEach((item) => {
                        products.push(item);
                    });
                }
            }
        });
        products = filter((x) => x.parent_id, products);
        products = sortWith([descend((x) => x.parent.stats.rating_count)], products);
        return { products };
    }

    componentDidMount() {
        this.props.getCategories();
        this.props.getCompanies({});
        this.props.getRecents({ per_page: 8 });
    }

    componentDidUpdate(prevProps, prevState) {
        if (prevProps.companies !== this.props.companies) {
            this.setState({
                mappedCompanies: this.props.companies.map((data) => ({
                    id: data.id,
                    value: data.name,
                    label: data.name,
                    name: data.name,
                })),
            });
        }
    }

    handleRateProduct = () => {};

    handleVendor = (e) => {
        const { categories } = this.props;
        const { all } = categories;
        const category = find(propEq('id', e[0]), all);
        this.props.getDetail({ categoryId: e[0], payload: { per_page: 25 } });
        const product = category.popular.data[0];
        const { parent } = product;
        this.setState({ companyName: parent, vendor: e });
    };

    handleOpenCategoryDetail = (item) => (event) => {
        event.preventDefault();
        this.props.getDetail({
            categoryId: item.id,
            payload: { per_page: 25 },
            route: `/vendor-ratings/by-category/${item.id}`,
        });
    };

    handleAddProduct = (from) => () => {
        const after =
            from === 'Easy Company'
                ? {
                      type: 'MODAL_REQUEST',
                      payload: {
                          type: 'Add Product',
                          data: { before: { from, default: null } },
                      },
                  }
                : null;
        this.props.toggleModal({
            type: `Add ${capitalize(from)}`,
            data: { before: { from, after } },
        });
    };

    handleSelectCategoryCallback = (e) => {
        this.setState({ productList: e?.data });
    };

    handleSelectCompanyCallback = (e) => {
        this.setState({ productList: e.company?.products || [] });
    };

    handleChangeDropdown = (type) => (e) => {
        if (type === 'company') {
            // this.setState({ selectedCompany: e })
            this.setState({ selectedCompany: [e.id] });
            this.setState({ company: e });
            this.props.getCompany({
                companyId: e.id,
                callback: this.handleSelectCompanyCallback,
            });
        }
        if (type === 'category') {
            this.setState({ selectedCategory: e });
            this.props.getDetail({
                categoryId: e[0],
                payload: {},
                callback: this.handleSelectCategoryCallback,
            });
        }
        if (type === 'product') {
            this.setState({ selectedProduct: e });
        }
    };

    handleOpenRateVendor = () => {
        const { loginUser, location } = this.props;
        const { activeTab, rating, recommend, selectedCategory, selectedCompany, selectedProduct } = this.state;
        const payload = {
            type: 'Rate Vendor',
            data: {
                before: {
                    tab: activeTab,
                    company: selectedCompany[0],
                    category: selectedCategory[0],
                    product: selectedProduct[0],
                    rating,
                    recommend,
                },
            },
            callBack: this.handleClear(),
        };
        if (loginUser?.id) {
            if (String(loginUser?.profile?.member_type) !== '0') {
                toast.error('Sorry, only dealers can leave reviews.', {
                    position: toast.POSITION.TOP_RIGHT,
                    pauseOnFocusLoss: false,
                    hideProgressBar: true,
                });
                return;
            }
            this.props.toggleModal(payload);
        } else {
            const route = `${location.pathname}${location.search}`;
            const after = { type: 'MODAL_REQUEST', payload };
            this.props.toggleModal({
                type: 'Authentication',
                data: { before: { route, after } },
            });
        }
    };

    handleClear = () => {
        this.setState({
            rating: 0,
            recommend: 0,
        });
    };

    getCompany = (search = '') => {
        this.props.getCompanies({ search });
    };
    handleSearch = (e) => {
        if (e !== '') this.getCompany(e);
    };
    handleChangeTab = (e) => {
        this.setState({
            activeTab: e,
            rating: 0,
            recommend: 0,
            selectedCategory: [null],
            selectedProduct: [null],
            company: '',
        });
    };

    handleOpenRate = () => {
        const { authenticated } = this.props;
        if (authenticated) {
            this.props.toggleModal({
                type: 'Rate Vendor',
                data: { before: { company: null, category: null, product: null } },
            });
        } else {
            const route = history.location.pathname;
            this.props.toggleModal({ type: 'Authentication', data: { before: { route } } });
        }
    };

    render() {
        const { showProducts, rating, recommend, activeTab, company, productList, selectedCompany, selectedCategory, selectedProduct } = this.state;
        const { authenticated, categories, companies, recentProducts, loginUser } = this.props;
        const { all, popular } = categories;

        const popularCategories = sort(descend(prop('product_total')), popular);

        const RecommendSymbol = [...Array(10)].map((item, idx) => {
            let styleClass = `rate-vendor-recommend-rate`;
            if (idx + 1 === recommend) styleClass = `active ${styleClass}`;
            return (
                <div key={`rating-${idx}`} className={styleClass}>
                    {idx + 1}
                </div>
            );
        });

        return (
            <ErrorBoundary className="vendor-home">
                <Helmet>
                    <title>Dealership vendor ratings, CRM, DMS, Marketing reviews | DrivingSales</title>
                    <meta name="description" content="Dealership vendor ratings, CRM, DMS, Marketing reviews | DrivingSales" />
                </Helmet>
                <div className="categories">
                    <div className="inner-content">
                        <p className="dsl-w22 mt-5 mt-md-0">Vendor Ratings</p>
                        <p className="dsl-w28 mb-5 text-center">How progressive dealers select vendors</p>
                        <div className="d-flex category-btn-wrap mb-5 mb-md-0">
                            <Button className="core-button" type="medium" name="By Category" onClick={() => this.props.navigate('/vendor-ratings/by-category')} />
                            <Button className="core-button" type="medium" name="By Company" onClick={() => this.props.navigate('/vendor-ratings/by-company')} />
                            <Button className="core-button" type="medium">
                                <SearchBox />
                            </Button>
                        </div>
                        <div className="d-flex-jc-center mt-4">
                            <Button className="core-button" type="medium" name="Rate Vendor" onClick={() => this.handleOpenRate()} />
                        </div>
                    </div>
                </div>
                <div className="popular-categories my-5">
                    <div className="d-flex jc-center">
                        <span className="dsl-b28 text-400 mt-4 title-color">Popular Categories</span>
                    </div>
                    <div className="container">
                        <Row className="items py-4 px-5">
                            {popularCategories.map((item, index) => {
                                const reviews = parseInt(item.data.ratings.avg_rating_count);
                                return (
                                    index <= 7 && (
                                        <Col className="text-center contents py-4" xs={6} sm={4} md={3} onClick={this.handleOpenCategoryDetail(item)} key={`popular-category-${item.id}`}>
                                            <Icon name={icon[index]} color="#8c8c8c" size={22} />
                                            <p className="dsl-b14 text-400 mb-2 popular-category-title">{`${item.name}`}</p>
                                            <p className="dsl-m12 mb-0">
                                                {`${item?.product_total || 0} Products`}/{`${item?.total_verified_ratings || 0} Reviews`}
                                            </p>
                                        </Col>
                                    )
                                );
                            })}
                        </Row>
                    </div>
                    <div className="d-flex jc-center cate-btn pb-4">
                        <Button
                            name="All Categories"
                            className="btn-cate"
                            onClick={() => {
                                this.props.navigate('/vendor-ratings/by-category');
                            }}
                        />
                    </div>
                </div>
                <div className="how-vendor py-5">
                    <div className="inner-content py-4">
                        <p className="dsl-w22">How Vendor Ratings Works</p>
                        <div className="container">
                            <Row className="d-h-center mb-4">
                                {vendorWorks.map((item, index) => {
                                    return (
                                        <Col xs={12} sm={3} className="item" key={`vendor-work-${index}`}>
                                            <div className="circle mb-3">
                                                <Icon name={item.icon} size={30} color="#fff" />
                                            </div>
                                            <div className="text-center">
                                                <p className="dsl-w14 mb-2">{item.info}</p>
                                            </div>
                                        </Col>
                                    );
                                })}
                            </Row>
                        </div>
                        <div className="d-flex">
                            <Button className="btn-vendor" type="medium" name="Find Vendors" onClick={() => this.props.navigate('/vendor-ratings/by-category')} />
                        </div>
                    </div>
                </div>
                <div className="dealer-satisfaction py-5">
                    <div className="inner-content py-5">
                        <Image src="/images/DSA_logo_Big_Image.png" width="300px" />
                        <p className="dsl-w16 my-4 desc">Honoring those products with the highest {'\n'} dealer satisfaction.</p>
                        <Button className="read-more" type="medium" name="View Winners" onClick={() => this.props.navigate('/vendor-ratings/dealer-satisfaction-award')} />
                    </div>
                </div>

                {/* <div className="card mt-3">
          <div className="d-flex justify-content-between mb-4">
            <span className="dsl-b22 bold">Popular Products</span>
            <span className="dsl-b16">Scroll for more >></span>
          </div>
          <div className="d-flex">
            <Row className="p-3 mx-0">
              {products.map((product, index) => {
                if (index < showProducts) {
                  const url = convertUrl(product.logo, '/images/default_company.svg')
                  const score = parseFloat(product.parent?.stats?.rating_avg)
                  const rating = parseFloat(product.parent?.stats?.rating_recommended_avg)
                  return (
                    <Col xs={3} key={product.id} className="mb-3">
                      <Product
                        logo={url}
                        title={product.name}
                        score={Number(score).toFixed(1)}
                        recommendation={Number(rating).toFixed(1)}
                        onClick={() => navigate(`/vendor-ratings/products/${product.id}`)}
                      />
                    </Col>
                  )
                }
              })}
            </Row>
          </div>
          <div className="d-flex justify-content-end">
            <Button className="mt-3" type="medium" name="SEE ALL" />
          </div>
        </div> */}

                <div className="card mt-3">
                    <div className="d-flex jc-center mb-4">
                        <span className="dsl-b28 text-400 mt-4 title-color">Recently Updated</span>
                    </div>
                    <div className="d-flex">
                        <div className="container">
                            <Row className="p-3 mx-0 product-row">
                                {isEmpty(recentProducts.data)
                                    ? 'No Updates Available'
                                    : recentProducts.data.map((product, index) => {
                                          if (index < showProducts) {
                                              const url = convertUrl(product.logo, '/images/default_company.svg');
                                              const score = parseFloat(product.parent?.stats?.rating_avg ?? 0);
                                              const rating = parseFloat(product.parent?.stats?.rating_recommended_avg ?? 0);
                                              return (
                                                  <Col xs={3} key={product.id} className="mb-3 mw-100 d-flex flex-column">
                                                      <Product
                                                          logo={url}
                                                          title={product.name}
                                                          score={Number(score).toFixed(1)}
                                                          recommendation={Number(rating).toFixed(1)}
                                                          onClick={() => this.props.navigate(`/business/${product?.slug}?id=${product?.business_id}`)}
                                                          isSponsored={product.data.sponsored_level === 'gold' || product.data.sponsored_level === 'silver'}
                                                      />
                                                  </Col>
                                              );
                                          }
                                      })}
                            </Row>
                        </div>
                    </div>
                </div>
                <div className="rate-vendor">
                    <p className="dsl-b28 text-400 mb-4 text-center">Rate a Vendor</p>
                    <div className="rate-vendor-card shadow-sm">
                        <Tabs className="bg-white" defaultActiveKey="company" activeKey={activeTab} onSelect={this.handleChangeTab}>
                            <Tab eventKey="company" title="By Company">
                                <div className="d-flex mt-3">
                                    <span className="dsl-m12 ai-s-center comapny-select-title ssm-100 pb-1 pe-1">Company</span>
                                    {this.state.mappedCompanies.length ? (
                                        <Select
                                            className="comapny-select-list ms-4 ssm-l-0 w-80 ssm-100"
                                            dataCy="selectCompany"
                                            isSearchable
                                            options={this.state.mappedCompanies}
                                            value={this.state.company}
                                            onChange={this.handleChangeDropdown('company')}
                                            onInputChange={this.handleSearch}
                                        />
                                    ) : (
                                        <span className="dsl-m12 ps-4">Loading...</span>
                                    )}
                                </div>
                                {/* <Dropdown
                  className="py-3 rate-vendor-dropdown"
                  title="Company"
                  width="fit-content"
                  defaultIds={selectedCompany}
                  data={companies}
                  getValue={e => e.name}
                  onChange={this.handleChangeDropdown('company')}
                /> */}
                            </Tab>
                            <Tab eventKey="category" title="By Category">
                                <Dropdown
                                    className="py-3 rate-vendor-dropdown"
                                    title="Category"
                                    width="fit-content"
                                    defaultIds={selectedCategory}
                                    data={all}
                                    getValue={(e) => e.name}
                                    onChange={this.handleChangeDropdown('category')}
                                />
                            </Tab>
                        </Tabs>
                        <Dropdown
                            className="py-3 rate-vendor-dropdown"
                            title="Product"
                            width="100%"
                            defaultIds={selectedProduct}
                            data={productList}
                            getValue={(e) => e.name}
                            onChange={this.handleChangeDropdown('product')}
                        />
                        <div className="d-h-start">
                            <Rating className="py-3 rate-vendor-rating" title="Star Rating" readonly={false} score={rating} size="large" fractions={2} onChange={(e) => this.setState({ rating: e })} />
                            {RATING_STATUS[rating.toFixed(0)] && (
                                <div className="rate-vendor-modal-status">
                                    <span className="dsl-b22">{RATING_STATUS[rating.toFixed(0)]}</span>
                                </div>
                            )}
                        </div>
                        <Rating
                            className="py-3 rate-vendor-modal-rating"
                            title="Likely to recommend?"
                            readonly={false}
                            showScore={false}
                            score={recommend}
                            size="large"
                            topRate={10}
                            empty={RecommendSymbol}
                            full={RecommendSymbol}
                            feedback={['Poor', 'Good', 'Excellent']}
                            onChange={(e) => this.setState({ recommend: e })}
                        />
                        <div className="pt-3 d-h-end">
                            <Button name="Submit" onClick={this.handleOpenRateVendor} />
                        </div>
                    </div>
                    <div className="rate-vendor-bottom text-center mt-4">
                        <p className="dsl-b12 mb-2">Didn't find what you were looking for?</p>
                        <div className="d-flex dsl-b12 mb-0 rate-btn jc-center ai-center">
                            <div>
                                <Button className="bold" type="link" name="Add Company" disabled={!authenticated} onClick={this.handleAddProduct('Easy Company')} />
                            </div>
                            <div>Or</div>
                            <div>
                                <Button className="bold" type="link" name="Add Product" disabled={!authenticated} onClick={this.handleAddProduct('product')} />
                            </div>
                        </div>
                    </div>
                </div>
            </ErrorBoundary>
        );
    }
}

Home.propTypes = {
    authenticated: PropTypes.bool.isRequired,
    categories: PropTypes.shape({
        all: PropTypes.array,
        popular: PropTypes.array,
    }),
    companies: PropTypes.array,
    loginUser: PropTypes.shape({
        id: PropTypes.number,
        profile: PropTypes.shape({
            member_type: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
        }),
    }),
    getCompanies: PropTypes.func,
};

Home.defaultProps = {
    authenticated: false,
    categories: {
        all: [],
        popular: [],
    },
    companies: [],
    loginUser: {
        id: 0,
        profile: {
            member_type: '3', // other
        },
    },
    getCompanies: () => {},
    getCategories: () => {},
    getDetail: () => {},
    toggleModal: () => {},
};

const mapStateToProps = (state) => ({
    authenticated: !isEmpty(state.app.token),
    categories: state.vendor.categories,
    loginUser: state.app.user?.community_user,
    recentProducts: state.vendor.recentProducts,
    companies: state.vendor.allVRCompanyInfo,
});

const mapDispatchToProps = (dispatch) => ({
    getCompanies: (e) => dispatch(VendorActions.getallvendorcompaniesRequest(e, false)),
    getCompany: (e) => dispatch(VendorActions.getvrcompanydetailRequest(e)),
    getCategories: () => dispatch(VendorActions.getcategoriesRequest()),
    getCompaniesInfo: (e) => dispatch(VendorActions.getallvendorcompaniesRequest(e)),
    getDetail: (e) => dispatch(VendorActions.getcategoryproductsRequest(e)),
    getRecents: (e) => dispatch(VendorActions.getrecentlyupdatedproductsRequest(e)),
    toggleModal: (e) => dispatch(AppActions.modalRequest(e)),
});

export default withNavigate(connect(mapStateToProps, mapDispatchToProps)(Home));
